import React, { useEffect, useState } from 'react'
import store from '../store/store'

export default function EditProfile({ setToggleEdit}) {
    const user = store((state) => state.user)
    const setUser = store((state) => state.setUser)

    const [formData, setFormData] = useState({
        firstName: user.firstName,
        lastName: user.lastName,
        userName: user.userName,
        email: user.email,
        location: user.location,
        birthDate: user.birthDate,
        avatar: user.avatar,
        newsletter: user.newsletter,
    })

    const [emailError, setEmailError] = useState(false)

    const handleChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        setFormData({ ...formData, [e.target.name]: value })
    }

    // Regular expression to validate email addresses
    const isEmailValid = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }

    const handleSaveButton = () =>{
        try {
            if (isEmailValid(formData.email)) {
                setEmailError(false)
                setUser({ ...user, ...formData })
                setToggleEdit(false)
            } else {
                setEmailError(true)
            }
        } 
        catch {
            console.error("Error occurs while saving user data")
        }
    }

    return (
        <div id="edit_account_general">
        <div id="userDetails_container">
            <h3>Edit Profile</h3>

            <form htmlFor='editAccount' id='edit_account_container'>
                
                <div id="edit_account_form_row">
                    <label htmlFor="firstName">First Name:</label>
                    <input
                        type="text"
                        id="edit_account_firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                    />
                </div>

                <div id="edit_account_form_row">
                    <label htmlFor="lastName">Last Name:</label>
                    <input
                        type="text"
                        id="edit_account_lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        />
                </div>

                <div id="edit_account_form_row">
                    <label htmlFor="userName">User Name:</label>
                    <input
                        type="text"
                        id="edit_account_userName"
                        name="userName"
                        value={formData.userName}
                        onChange={handleChange}
                    />
                </div>

                <div id="edit_account_form_row">  
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="edit_account_email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {emailError&& <p id='account_form_error'>Wrong Email Format</p>}
                </div>

                <div id="edit_account_form_row">  
                    <label htmlFor="location">Location:</label>
                    <input
                        type="text"
                        id="edit_account_location"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                    />
                </div>

                <div id="edit_account_form_row">
                    <label htmlFor="birthDate">Birth Date:</label>
                    <input
                        type="date"
                        id="edit_account_birthDate"
                        name="birthDate"
                        value={formData.birthDate}
                        onChange={handleChange}
                    />
                </div>
                
                <div id="edit_account_form_row">
                    <label htmlFor="avatar">Avatar (Picture URL):</label>
                    <input
                        type="text"
                        id="edit_account_avatar"
                        name="avatar"
                        value={formData.avatar}
                        onChange={handleChange}
                    />
                </div>

                <div id='edit_account_form_row'>
                    <label htmlFor='newsletter'>Subscribe to the Newsletter?</label>
                    <input
                        type="checkbox"
                        id="edit_account_newsletter"
                        name="newsletter"
                        checked={formData.newsletter}
                        onChange={handleChange}
                    />
                </div>
            
            </form>

            <div id='edit_account_button_container'>
                <button id="edit_account_button" onClick={() => setToggleEdit(false)}>
                    Cancel
                </button>
                <button id="edit_account_button" onClick={handleSaveButton}>
                    Save
                </button>
            </div>
        </div>
        </div>
    )
}
